export default __webpack_public_path__ + "static/footer_wave_mobile-3c759eb14a936d7c232b40ffda810d9a.svg";